const fullPosts = [
  {
    slug: "yamactepe-modern-yasam",
    breadcrumbs: ["Ana Sayfa", "Blog", "Yamaçtepe"],
    subTitle: "modern yaşam",
    history: "Haziran 24, 2025",
    title: "Yamaçtepe'de Yeni Nesil Yaşam Alanları: Tetra Yapı'nın Vizyonu",
    paragraph1: "Yamaçtepe, Gaziantep’in yükselen değerlerinden biri. Gelişen ulaşım altyapısı, doğayla iç içe konumu ve düzenli yapılaşmasıyla dikkat çeken bu bölgede Tetra Yapı, modern yaşam konseptiyle öne çıkan projeler geliştiriyor.",
    paragraph2Title: "Yeni Nesil Mahalle Anlayışı",
    paragraph2: "Yamaçtepe’deki projeler sadece konut değil; bir yaşam kültürü sunuyor. Mahalle içi sosyal alanlar, yürüyüş yolları, çocuk parkları, güvenli site yaşamı gibi detaylarla hem genç çiftlere hem de ailelere hitap ediyor.",
    listItems: [
      "Geniş peyzaj alanları",
      "Yüksek güvenlikli site yapısı",
      "Çocuk dostu çevre tasarımı"
    ],
    paragraph3: "Yamaçtepe’de hayata geçirilen projelerde, enerji verimliliği, doğal ışık kullanımı, bölgesel rüzgar yönlerine göre yerleşim gibi modern mimari kriterler ön planda tutuluyor. Tetra Yapı’nın bu bölgedeki çalışmaları, şehrin doğayla barışık gelişimine örnek teşkil ediyor.",
    tags: ["Yamaçtepe", "Tetra Yapı", "Modern Yaşam", "Gaziantep"],
    author: {
      name: "Burak Aydın",
      role: "Mimarlık Editörü",
      bio: "Yeni nesil konut projeleri ve sürdürülebilir mimari üzerine yazılar yazar.",
      image: "/innerpages/assets/img/team/team2.jpg"
    },
    images: [
      {
        src: "/innerpages/assets/img/blog/b16.jpg",
        caption: "Yamaçtepe - Sosyal Alan Görünümü"
      },
      {
        src: "/innerpages/assets/img/blog/b17.jpg",
        caption: "Doğayla iç içe modern konutlar"
      }
    ],
    relatedPosts: [
      {
        title: "Gaziantep’te Konut Tercihleri Nasıl Değişiyor?",
        img: "/innerpages/assets/img/blog/b3.jpg",
        tags: ["Konut", "Gaziantep"],
        date: "Mayıs 25, 2025"
      },
      {
        title: "Tetra Yapı’nın Sürdürülebilirlik Yaklaşımı",
        img: "/innerpages/assets/img/blog/b5.jpg",
        tags: ["Tetra Yapı", "Yeşil Binalar"],
        date: "Haziran 10, 2025"
      }
    ]
  },
  {
    slug: "aktoprak-doga-ve-modernlik",
    breadcrumbs: ["Ana Sayfa", "Blog", "Aktoprak"],
    subTitle: "doğayla iç içe",
    history: "Haziran 20, 2025",
    title: "Aktoprak’ta Doğayla Bütünleşmiş Modern Konutlar",
    paragraph1: "Gaziantep’in batısında yer alan Aktoprak, temiz havası ve geniş yeşil alanlarıyla dikkat çekiyor. Tetra Yapı’nın bu bölgede geliştirdiği projeler, modern konforu doğayla bütünleştirme amacı taşıyor.",
    paragraph2Title: "Yeşil Alan Odaklı Yerleşim Planları",
    paragraph2: "Projeler, yapı yoğunluğu azaltılmış, ortak kullanım alanlarına önem verilmiş şekilde planlanıyor. Her dairenin geniş balkonları, bahçeye açılan zemin katlar ve gün ışığını maksimum kullanmaya yönelik cephe çözümleri mevcut.",
    listItems: [
      "Düşük katlı yapılaşma",
      "Doğal taş ve ahşap malzeme kullanımı",
      "Geniş balkonlar ve teraslar"
    ],
    paragraph3: "Aktoprak’taki projeler, sürdürülebilir yaşam ilkelerine sadık kalınarak planlanıyor. Yağmur suyu toplama sistemleri, enerji tasarruflu aydınlatmalar ve geri dönüşüm alanları gibi çevreci çözümlerle bölgeye değer katıyor.",
    paragraph4Title: "Tetra Yapı’nın Aktoprak’taki Mimari Yaklaşımı",
    paragraph4: "Tetra Yapı, Aktoprak’ta hayata geçirdiği projelerde yalnızca estetik değil, aynı zamanda işlevselliği de ön planda tutuyor. Bölgenin doğal eğimi, güneş alma potansiyeli ve rüzgar yönü gibi çevresel veriler dikkate alınarak konutlar konumlandırılıyor. Bu sayede her bir birim gün ışığından maksimum fayda sağlarken, yaz aylarında serin kalacak şekilde tasarlanıyor. Ayrıca sosyal alanlar, araç trafiğinden izole edilmiş şekilde planlanarak çocukların ve yaşlıların güvenli bir çevrede vakit geçirmesi sağlanıyor. Bu bütüncül tasarım anlayışı, Aktoprak’ta yeni bir yaşam standartı oluşturuyor.",
    tags: ["Aktoprak", "Doğa Dostu", "Tetra Yapı", "Gaziantep"],
    author: {
      name: "Mustafa Culha",
      role: "İçerik Editörü",
      bio: "Kentsel gelişim, çevre dostu yapı ve mimari estetik üzerine yazar.",
      image: "/innerpages/assets/img/team/team1.jpg"
    },
    images: [
      {
        src: "/innerpages/assets/img/blog/b18.jpg",
        caption: "Aktoprak - Tetra Konut Projeleri"
      },
      {
        src: "/innerpages/assets/img/blog/b19.jpg",
        caption: "Doğa ile uyumlu site planları"
      }
    ],
    relatedPosts: [
      {
        title: "Gaziantep’te Yükselen Yaşam Alanları",
        img: "/innerpages/assets/img/blog/b6.jpg",
        tags: ["Gaziantep", "Konut Bölgeleri"],
        date: "Haziran 5, 2025"
      },
      {
        title: "Modern Konutlarda Çevre Bilinci",
        img: "/innerpages/assets/img/blog/b7.jpg",
        tags: ["Yeşil Yaşam", "Modern Mimari"],
        date: "Mayıs 30, 2025"
      }
    ]
  }
];

export default fullPosts;